export default __webpack_public_path__ + "static/media/video1.15933f49.mp4";